import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase-config";
import { Users, User, FileText, ClipboardList, Activity } from "lucide-react";
import { Link } from "react-router-dom";
import {setPageTitle} from "../../store/themeConfigSlice";
import {useDispatch} from "react-redux";

const Dashboard = () => {
    const dispatch = useDispatch();

    const [stats, setStats] = useState({
        users: 0,
        patients: 0,
        visits: 0,
        interventionRecords: 0,
        syariahInterventions: 0,
    });

    useEffect(() => {
        dispatch(setPageTitle("Dashboard"));
    }, [dispatch]);

    useEffect(() => {
        const fetchData = async () => {
            const usersSnapshot = await getDocs(collection(db, "users"));
            const patientsSnapshot = await getDocs(collection(db, "patients"));
            const visitsSnapshot = await getDocs(collection(db, "visits"));
            const interventionRecordsSnapshot = await getDocs(collection(db, "intervention_records"));
            const syariahInterventionsSnapshot = await getDocs(collection(db, "syariah_interventions"));

            setStats({
                users: usersSnapshot.size,
                patients: patientsSnapshot.size,
                visits: visitsSnapshot.size,
                interventionRecords: interventionRecordsSnapshot.size,
                syariahInterventions: syariahInterventionsSnapshot.size,
            });
        };

        fetchData();
    }, []);

    const statItems = [
        { key: "users", label: "Users", icon: Users, link: "/user-management" },
        { key: "patients", label: "Patients", icon: User, link: "/patients" },
        { key: "visits", label: "Visits", icon: FileText, link: "/visits" },
        { key: "interventionRecords", label: "Intervention Records", icon: ClipboardList, link: "#" },
        { key: "syariahInterventions", label: "Syariah Interventions", icon: Activity, link: "/syariah-interventions" },
    ];

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Dashboard</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                {statItems.map(({ key, label, icon: Icon, link }) => (
                    <Link to={link} key={key} className="block">
                        <div className="p-4 dark:bg-gray-800 rounded-lg  shadow-md flex items-center space-x-3 transition-transform transform hover:scale-105 cursor-pointer">
                            <Icon className="w-8 h-8 dark:text-blue-400 text-blue-500" />
                            <div>
                                <h2 className="text-sm font-semibold dark:text-gray-300 text-gray-700 ">{label}</h2>
                                <p className="text-xl font-bold text-gray-900 dark:text-white">{stats[key]}</p>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Dashboard;
